<template>
    <div class="spinner-root spinner-border" :class="`spinner-border-${size}`" role="status">
        <span class="sr-only">{{ $t('general.loading') }}...</span>
    </div>
</template>

<script>
export default {
    props: {
        size: {
            type: String,
            default: 'lg',
        },
    },
};
</script>

<style scoped>
.spinner-root {
    color: inherit;
}
.spinner-border-lg {
    width: 3rem !important;
    height: 3rem !important;
}

.spinner-border-xs {
    width: 0.7rem !important;
    height: 0.7rem !important;
    border-width: 1px;
}
</style>
